var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import classNames from 'classnames';
import BaseButton from '../BaseButton';
import * as styles from './primaryButton.linaria';
import { ButtonLoader } from './ButtonLoader';
export const ButtonSizes = ['big', 'standard', 'small'];
/**
 * The primary button of the library. Currently the library only has two buttons; `BaseButton` and `PrimaryButton`,
 * but we will most likely implement more buttons as we continue the development.
 */
export const PrimaryButton = forwardRef((_a, ref) => {
    var { children, size = 'standard', fill, fullWidth, isLoading, disabled, ariaLabel } = _a, props = __rest(_a, ["children", "size", "fill", "fullWidth", "isLoading", "disabled", "ariaLabel"]);
    return (<BaseButton {...props} disabled={disabled || isLoading} ariaLabel={isLoading ? 'Loading' : ariaLabel} ref={ref} className={classNames(props.className, size, fill && 'filled', fullWidth && 'full-width', styles.primaryButton)}>
        {isLoading && <ButtonLoader />}
        <div className={classNames(isLoading && 'isLoading', 'buttonLoaderWrapper')}>
          {children}
        </div>
      </BaseButton>);
});
PrimaryButton.defaultProps = {
    size: 'standard',
    fill: false,
    fullWidth: false,
    isLoading: false,
};
export default PrimaryButton;
